// Lock

// ___________________________________________________________________

import * as React from 'react'
import theme from '../../gatsby-plugin-theme-ui'

// ___________________________________________________________________

const Lock = () => (
  <svg viewBox="0 0 41.23 55.51">
    <title>Lock icon</title>
    <path
      d="M21,1.12A13.39,13.39,0,0,1,34.36,14.49v4.32h6.5V55.14H1.12V18.81H7.61V14.49A13.39,13.39,0,0,1,21,1.12M10.83,18.81H31.15V14.49a10.16,10.16,0,0,0-20.32,0v4.32m7.06,19.34v2.64a2.92,2.92,0,0,0,3,3,2.91,2.91,0,0,0,3-3V38.26A4.57,4.57,0,0,0,21,30.12a4.47,4.47,0,0,0-4.64,4.58,4.6,4.6,0,0,0,1.54,3.45M21,.37A14.13,14.13,0,0,0,6.87,14.49v3.58H.37V55.89H41.6V18.07H35.11V14.49A14.13,14.13,0,0,0,21,.37Zm-9.42,17.7V14.49a9.42,9.42,0,0,1,18.83,0v3.58Zm9.34,25a2.18,2.18,0,0,1-2.28-2.25v-3a3.86,3.86,0,0,1-1.54-3.09A3.72,3.72,0,0,1,21,30.87a3.82,3.82,0,0,1,2.19,7v2.92A2.17,2.17,0,0,1,20.91,43Z"
      transform="translate(-0.37 -0.37)"
    />
  </svg>
)

export default Lock
